module.exports = new __parcel__URL__("attachments-preview-dark.33a03e0d.svg").toString();